module.exports = __webpack_public_path__ + "static/img/10.18d5456.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/10.png
// module id = An6w
// module chunks = 0